import ttf from './OpenSans-Regular.ttf';
import woff from './OpenSans-Regular.woff';
import woff2 from './OpenSans-Regular.woff2';

export default {
  name: 'OpenSans',
  variant: 'Regular',
  ttfUrl: ttf,
  woffUrl: woff,
  woff2Url: woff2,
} as const;
